import React from 'react'
import Alert from 'react-bootstrap/Alert'
import { Icon } from '../icon'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { useActions, useError } from '../../store'

/** an Alert that displays the 'error' value from the store */
const DangerAlert = () => {
  const error = useError()
  const { setError } = useActions()

  return error ? (
    <Alert variant='danger' dismissible onClose={() => setError('')}>
      <Icon icon={faExclamationCircle} size='lg' />
      {error}
    </Alert>
  ) : null
}

export { DangerAlert }
